import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "name" }

import { useStore } from 'vuex';
  import { computed,onMounted } from 'vue';
  import EditNameModal from "../EditNameModal.vue";
  import { debounce } from 'lodash'; // 确保安装了 lodash
  import { ref } from 'vue';
  import {
  EditOutlined,
} from "@ant-design/icons-vue";
  import { ExternalFun } from '../../ExternalFun';
  interface User {
    name: string;
    imgId: number;
  }

  interface Session {
    id: number;
    user: {
      name: string;
      imgId: number;
    };
    messages: any[]; // 可以定义 MessageItem 类型
  }
  
  
  // 使用 Composition API
  
export default /*@__PURE__*/_defineComponent({
  __name: 'right',
  setup(__props) {

  const editNameModalVisible = ref(false);
  const imageUrl = ref(null);
  // 定义接口 (类型)
  const store = useStore();
  
 
 const getCurSessionNickName = ()=>{
  let currentId = store.state.currentSessionId;
  let session = store.state.sessions.find((item) => item.id === currentId);
  if(session == undefined)
  {
     return ""
  }
  return session.user.name;

 }

 const showEditNameModal = () => {
   console.log("showEditNameModal");
   editNameModalVisible.value = true;
};


  // 搜索函数 (防抖处理)
  const onKeyup = debounce((value: string) => {
    store.commit('SET_FILTER_KEY', value); // 触发 mutation
  }, 150); // 150ms 防抖延迟
  
  // 本地 onKeyup 函数，用于处理 input 事件
  const handleKeyup = (e: Event) => { // KeyboardEvent -> Event
    const target = e.target as HTMLInputElement;
    onKeyup(target.value); // 调用防抖函数
  };

  onMounted(async () => {
 
  })  

 

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", null, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(getCurSessionNickName()), 1)
      ])
    ]),
    _createVNode(EditNameModal, {
      visible: editNameModalVisible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((editNameModalVisible).value = $event))
    }, null, 8, ["visible"])
  ], 64))
}
}

})